module.exports = __webpack_public_path__ + "static/media/logo.1cbc22f7.png";